/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardType
 */
export interface CardType {
    /**
     * 
     * @type {string}
     * @memberof CardType
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CardType
     */
    id?: string;
}

export function CardTypeFromJSON(json: any): CardType {
    return CardTypeFromJSONTyped(json, false);
}

export function CardTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function CardTypeToJSON(value?: CardType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
    };
}

